import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=9f57d0ac&scoped=true&"
import script from "./SortButton.vue?vue&type=script&lang=ts&"
export * from "./SortButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f57d0ac",
  null
  
)

export default component.exports